import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Copy } from 'src/svg/Copy';

interface ReferralLinkkProps {
  onCopyClick: () => void;
  referralLink: string;
  isModal?: boolean;
}

export const ReferralLink = ({
  onCopyClick,
  referralLink,
  isModal = false
}: ReferralLinkkProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-3 justify-between items-center p-1 pl-3 rounded-[10px] bg-surface_theme_secondary w-full">
      <p
        className={classNames(
          'truncate text-text_primary text-xs font-medium',
          isModal ? 'max-w-[327px]' : 'max-w-[400px]'
        )}>
        {referralLink}
      </p>
      <button
        onClick={onCopyClick}
        className="flex gap-2 items-center py-2 px-5 bg-surface_button_base_default border border-border_theme_secondary rounded-lg text-text_primary text-sm font-semibold">
        {t('referral.copy')} <Copy />
      </button>
    </div>
  );
};
